'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ContactInformation = require('./ContactInformation');

var _ContactInformation2 = _interopRequireDefault(_ContactInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CcdHeader = function CcdHeader(_ref) {
  var demographicsData = _ref.demographicsData;

  var renderPatientIdentifier = function renderPatientIdentifier(patientIdentifier, index) {
    if (patientIdentifier.identifierNumber && patientIdentifier.identifierType) {
      return _react2.default.createElement(
        'div',
        { key: patientIdentifier + '-' + index },
        patientIdentifier.identifierType + ": ",
        _react2.default.createElement('br', null),
        patientIdentifier.identifierNumber
      );
    } else return null;
  };

  var renderPatientIdentifiers = function renderPatientIdentifiers(patientIdentifiers) {
    var patientIdentifiersRenderArray = [];
    var patientIdentifiersRender = null;

    //check to make sure we have both a patient identifier type and number
    if (patientIdentifiers && patientIdentifiers.length > 0) {
      for (var i = 0; i < patientIdentifiers.length; i++) {
        if (patientIdentifiers[i].identifierNumber && patientIdentifiers[i].identifierType) {
          var patientIdentifierRender = renderPatientIdentifier(patientIdentifiers[i]);
          patientIdentifiersRenderArray.push(patientIdentifierRender);
        }
      }

      if (patientIdentifiersRenderArray.length > 0) {
        patientIdentifiersRender = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Patient Identifiers: '
          ),
          patientIdentifiersRenderArray
        );
      } else {
        patientIdentifiersRender = _react2.default.createElement(
          'h3',
          null,
          'Patient Identifiers: N/A '
        );
      }
    }
    return patientIdentifiersRender;
  };

  var parseItem = function parseItem(item) {
    if (item.constructor === Array) {
      if (item.length > 0) {
        return item.join(', ').toString();
      } else {
        return "N/A";
      }
    } else {
      return item;
    }
  };

  //Render the item if it exists, otherwise render N/A
  var renderItem = function renderItem(item) {
    if (item) {
      return parseItem(item);
    }
    return "N/A";
  };

  var renderMainName = function renderMainName(names) {
    if (names && names.length > 0) {
      if (names[0].fullName) {
        //We'll use the first fullName in the names array
        return names[0].fullName;
      }
    }
    //Default to N/A
    return "N/A";
  };

  var renderAlternateNames = function renderAlternateNames(names) {
    var namesString = null;
    if (names && names.length > 1) {
      namesString = "Alternate Names: ";
      for (var i = 1; i < names.length; i++) {
        if (names[i].fullName) {
          if (i > 1) {
            namesString += ", ";
          }
          namesString += names[i].fullName;
        }
      }
    }
    if (namesString !== null) {
      return _react2.default.createElement(
        'span',
        null,
        namesString
      );
    }
    return null;
  };

  var renderLanguages = function renderLanguages(languages) {
    var languagesArray = [];

    if (languages) {
      for (var i = 0; i < languages.length; i++) {
        if (languages[i].code) {
          var languageString = languages[i].code;
          var languageDetailsArray = [];
          if (languages[i].preferred) languageDetailsArray.push("Preferred");
          if (languages[i].proficiency) languageDetailsArray.push(languages[i].proficiency + " proficiency");
          if (languages[i].mode) languageDetailsArray.push(languages[i].mode);

          if (languageDetailsArray.length > 0) languageString += " (" + languageDetailsArray.join(', ').toString() + ")";

          languagesArray.push(languageString);
        }
      }
    }
    return languagesArray.map(function (languageData, index) {
      if (index === 0) return _react2.default.createElement(
        'span',
        { key: index },
        languageData
      );else return _react2.default.createElement(
        'div',
        { key: index },
        languageData
      );
    });
  };

  return _react2.default.createElement(
    'div',
    { className: 'ccdHeader dropShadow' },
    demographicsData && _react2.default.createElement(
      'div',
      { className: 'demographics' },
      _react2.default.createElement(
        'h1',
        null,
        renderMainName(demographicsData.names)
      ),
      _react2.default.createElement(
        'span',
        null,
        renderAlternateNames(demographicsData.names)
      ),
      _react2.default.createElement(
        'table',
        { className: 'headerData' },
        _react2.default.createElement(
          'tbody',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              { className: 'headerDataSection' },
              _react2.default.createElement(_ContactInformation2.default, { phoneList: demographicsData.phones, addressList: demographicsData.addresses, initialshouldShowAddress: true })
            ),
            _react2.default.createElement('td', { className: 'verticalLine' }),
            _react2.default.createElement(
              'td',
              { className: 'headerDataSection' },
              _react2.default.createElement(
                'h3',
                null,
                'Date Of Birth: '
              ),
              renderItem(demographicsData.birthDate),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'h3',
                null,
                'Age: '
              ),
              renderItem(demographicsData.age),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'h3',
                null,
                'Marital Status: '
              ),
              renderItem(demographicsData.maritalStatus),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'h3',
                null,
                'Sex: '
              ),
              renderItem(demographicsData.sex)
            ),
            _react2.default.createElement('td', { className: 'verticalLine' }),
            _react2.default.createElement(
              'td',
              { className: 'headerDataSection' },
              _react2.default.createElement(
                'h3',
                null,
                'Language: '
              ),
              renderLanguages(demographicsData.languages),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'h3',
                null,
                'Religious Affiliation: '
              ),
              renderItem(demographicsData.religiousAffiliation),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'h3',
                null,
                'Ethnicity: '
              ),
              renderItem(demographicsData.ethnicity),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'h3',
                null,
                'Race: '
              ),
              renderItem(demographicsData.race)
            ),
            _react2.default.createElement('td', { className: 'verticalLine' }),
            _react2.default.createElement(
              'td',
              { className: 'headerDataSection' },
              renderPatientIdentifiers(demographicsData.patientIdentifiers)
            )
          )
        )
      )
    )
  );
};

CcdHeader.propTypes = {
  demographicsData: _propTypes2.default.object //JS object with demographics properties
};

exports.default = CcdHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/updox-care-record-viewer/lib/reactComponents/CcdHeader.js
// module id = 1243
// module chunks = 0